<template>
  <form class="mt-3">
    <div class="d-flex flex-column">
      <p class="text-muted question">
        If you were considering a new payments provider, which company would be
        your first choice?
      </p>
    </div>
    <div class="md-layout overflow-x-scroll w-100" style="max-width: 100vw;">
      <md-field>
        <label>Your answer</label>
        <md-input v-model="answer" />
      </md-field>
    </div>
    <div v-if="hasError" class="alert alert-danger">
      Please enter a minimum of 3 characters.
    </div>
    <div
      class="md-layout-item md-size-100 d-flex justify-content-between align-items-center mt-3"
    >
      <div class="d-flex flex-row">
        <md-progress-spinner
          class="mx-3"
          :md-diameter="30"
          :md-stroke="loading ? 4 : 0"
          md-mode="indeterminate"
        ></md-progress-spinner>

        <md-button
          class="md-primary"
          :disabled="submitDisabled"
          @click="submit()"
        >
          Submit
        </md-button>
      </div>
    </div>
  </form>
</template>
<script>
import ApiService from "@/services/api";
import { toastLaravelErrors } from "@/mixins";

export default {
  name: "RegistrationForm",
  mixins: [toastLaravelErrors],
  data() {
    return {
      loading: false,
      answer: "",
      hasError: false
    };
  },
  computed: {
    valid() {
      return this.answer.length >= 3;
    },
    submitDisabled() {
      return this.loading || !this.valid;
    }
  },
  created() {
    ApiService.auth.setCSRF();
  },
  mounted() {
    this.$store.dispatch("disableAds");
  },
  methods: {
    submit() {
      if (!this.valid) {
        this.hasError = true;
        return;
      }

      this.loading = true;

      ApiService.survey
        .complete({ responses: { answer: this.answer } })
        .then(e => {
          this.$store.dispatch("getAuthUser");
          this.$store.dispatch("enableAds");
        })
        .catch(error => {
          this.toastLaravelErrors(error);

          if (error.response.status === 409) {
            this.$toast.error(error.response.data.message);
          } else {
            this.$toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style>
.question {
  font-size: 18px;
}

.bg-alt {
  background-color: #e7e7e7;
}

.cell-border {
  --bs-border-color: #b0b0b0;
}
</style>
